var map = {
	"./act": 1523,
	"./act.ts": 1523,
	"./gmat": 1524,
	"./gmat.ts": 1524,
	"./gre": 1525,
	"./gre.ts": 1525,
	"./ielts": 1526,
	"./ielts.ts": 1526,
	"./ielts_general_training": 1527,
	"./ielts_general_training.ts": 1527,
	"./lsat": 1528,
	"./lsat.ts": 1528,
	"./mcat": 1529,
	"./mcat.ts": 1529,
	"./sat": 1530,
	"./sat.ts": 1530,
	"./toefl": 1531,
	"./toefl.ts": 1531
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 2534;
module.exports = webpackAsyncContext;